import React from 'react'
import './Field.css'


const Field = ({FieldName,onchange,inputRef,value,onblur,typeInput,className,requis}) => {

  //const Regex_Nom= new RegExp(/^[a-z A-Z]{1,10}?$/)
 



  return (
    <div className='Champ'>
        <label htmlFor={FieldName}>{FieldName}{requis && <span className='required'>*<span className='infobulle'>Champ obligatoire</span></span>}</label>
        <input type={typeInput===''?'text':typeInput} name="field" id={FieldName} onChange={onchange} ref={inputRef} value={value} onBlur={onblur} className={className} placeholder={FieldName} min={0} step={5}/>
    </div>
  )
}

export default Field